import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiMembersKnowledgeInsightPostIndexType,
  SnakeCaseSortType,
} from "~/domains";

export type ApiMembersKnowledgeInsightPostsIndexParamsType = {
  keyword?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  hasComment?: boolean;
  hasBookmark?: boolean;
  employeeIds?: string[];
  employeeRoleId?: number;
  sortType?: SnakeCaseSortType;
};

type RequestDataType = {
  params?: ApiMembersKnowledgeInsightPostsIndexParamsType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiMembersKnowledgeInsightPostIndexType> => {
  const response =
    await new ApiClient().get<ApiMembersKnowledgeInsightPostIndexType>(
      "/api/members/knowledge_insight_posts",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiMembersKnowledgeInsightPostsIndexParamsType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersKnowledgeInsightPostsIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiMembersKnowledgeInsightPostIndexType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisMembersKnowledgeInsightPostsIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
